module.exports = __webpack_public_path__ + "static/media/hiw2.13821e7f.svg";